import { Link, Outlet, useNavigate } from 'react-router-dom'
import { useAuth } from '@/context/AuthContext'

export default function Layout() {
  const { user, isAuthenticated, logout } = useAuth()
  const navigate = useNavigate()

  const handleLogout = async () => {
    await logout()
    navigate('/')
  }

  return (
    <div className="min-h-screen flex flex-col">
      {/* Header */}
      <header className="bg-white shadow-sm">
        <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16">
            {/* Logo and main nav */}
            <div className="flex">
              <Link to="/" className="flex items-center">
                <span className="text-xl font-bold text-primary-600">IT Experts</span>
                <span className="text-xl font-light text-gray-500">.ie</span>
              </Link>

              <div className="hidden sm:ml-8 sm:flex sm:space-x-6">
                <Link
                  to="/experts"
                  className="inline-flex items-center px-1 pt-1 text-sm font-medium text-gray-500 hover:text-gray-900"
                >
                  Find Experts
                </Link>
                {isAuthenticated && user?.user_type === 'company' && (
                  <Link
                    to="/company/jobs/new"
                    className="inline-flex items-center px-1 pt-1 text-sm font-medium text-gray-500 hover:text-gray-900"
                  >
                    Post a Job
                  </Link>
                )}
              </div>
            </div>

            {/* Right side */}
            <div className="flex items-center space-x-4">
              {isAuthenticated ? (
                <>
                  <Link
                    to="/dashboard"
                    className="text-sm font-medium text-gray-500 hover:text-gray-900"
                  >
                    Dashboard
                  </Link>
                  <div className="relative">
                    <button
                      onClick={handleLogout}
                      className="text-sm font-medium text-gray-500 hover:text-gray-900"
                    >
                      Logout
                    </button>
                  </div>
                </>
              ) : (
                <>
                  <Link
                    to="/login"
                    className="text-sm font-medium text-gray-500 hover:text-gray-900"
                  >
                    Sign in
                  </Link>
                  <Link
                    to="/login?type=expert"
                    className="btn-primary text-sm"
                  >
                    Join as Expert
                  </Link>
                </>
              )}
            </div>
          </div>
        </nav>
      </header>

      {/* Main content */}
      <main className="flex-1">
        <Outlet />
      </main>

      {/* Footer */}
      <footer className="bg-gray-800 text-gray-300">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <h3 className="text-white font-semibold mb-4">IT Experts Ireland</h3>
              <p className="text-sm">
                Connecting verified IT professionals with opportunities across Ireland.
              </p>
            </div>
            <div>
              <h4 className="text-white font-medium mb-4">For Experts</h4>
              <ul className="space-y-2 text-sm">
                <li><Link to="/login?type=expert" className="hover:text-white">Join as Expert</Link></li>
                <li><Link to="/experts" className="hover:text-white">Browse Experts</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="text-white font-medium mb-4">For Companies</h4>
              <ul className="space-y-2 text-sm">
                <li><Link to="/login?type=company" className="hover:text-white">Hire Experts</Link></li>
                <li><Link to="/company/jobs/new" className="hover:text-white">Post a Job</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="text-white font-medium mb-4">Legal</h4>
              <ul className="space-y-2 text-sm">
                <li><a href="/privacy" className="hover:text-white">Privacy Policy</a></li>
                <li><a href="/terms" className="hover:text-white">Terms of Service</a></li>
                <li><a href="/gdpr" className="hover:text-white">GDPR</a></li>
              </ul>
            </div>
          </div>
          <div className="mt-8 pt-8 border-t border-gray-700 text-sm text-center">
            © {new Date().getFullYear()} IT Experts Ireland. All rights reserved.
          </div>
        </div>
      </footer>
    </div>
  )
}
